var map = {
	"./TenkoBall_1.json": [
		667,
		72
	],
	"./TenkoBall_2.json": [
		668,
		73
	],
	"./TenkoBall_3.json": [
		669,
		74
	],
	"./Tenko_Blast1.json": [
		670,
		75
	],
	"./Tenko_Blast2.json": [
		671,
		76
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1182;
module.exports = webpackAsyncContext;